import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import PlatformRoutes from './routes/PlatformRoutes';
import { AuthProvider } from './utils/AuthContext';
import { PlatformAuthProvider } from './utils/PlatformAuthContext';
import { getAppContext } from './config/appContext';
import { ConfigProvider, App as AntdApp } from 'antd';

function App() {
  const { mode } = getAppContext();
  const isPlatform = mode === 'platform';

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2E37A4',
        },
      }}
      warning={{ strict: false }}
    >
      <AntdApp>
        <div className="App">
          <Router>
            {isPlatform ? (
              <PlatformAuthProvider>
                <PlatformRoutes />
              </PlatformAuthProvider>
            ) : (
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            )}
          </Router>
        </div>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
